export default __webpack_public_path__ + "static/media/icon_logout.63fef68d.png";